import React, {Component} from "react";

import OmzetToppy from "./common/Omzet/Toppy";
import OmzetHeuts from "./common/Omzet/Heuts";

import {
    NAMESPACE_DEFAULT,
    NAMESPACE_CONTENT,
} from "../actions/types";

import {connect} from "react-redux";
import {openWebsocket} from "../actions/actions";
import PropTypes from "prop-types";
import MobileMenu from "./common/Profile/Mobile/MobileMenu";
import Loader from "./common/Loader";
import Reviews from "./common/Reviews/Main";
import Departments from "./Content/Departments"
import Achievements from "./Content/Achievements";
import OrdersHeuts from "./common/Orders/Heuts";
import OrdersToppy from "./common/Orders/Toppy";
import OrdersTable from "./common/Orders/OrdersTable";

class Content extends Component {
    componentDidMount() {
        this.connectSockets();
    }

    connectSockets = () => {
        this.props.openWebsocket(NAMESPACE_DEFAULT);
        this.props.openWebsocket(NAMESPACE_CONTENT);
    }


    render() {
        let {loaded} = this.props.result;
        if (loaded.toppyRevenue && loaded.heutsRevenue && loaded.analytics && loaded.revenuePerDepartment) {
            if (this.props.history.location.pathname === '/content') {
                return (
                    <div>
                        <div className={this.props.result.tvMode ? "content-dashboard tv" : "content-dashboard"}>
                            <div id="left" className="medium-column">
                                <OmzetToppy/>
                                <OrdersToppy/>
                                <div id="orders" className="block">
                                    <OrdersTable/>
                                </div>
                            </div>
                            <div id="center" className="medium-column">
                                <OmzetHeuts/>
                                <OrdersHeuts/>
                                <Reviews/>
                            </div>
                            <div id="right" className="medium-column">
                                <Departments />
                                <Achievements />
                            </div>
                        </div>
                        <MobileMenu/>
                    </div>
                );
            } else {
                return null
            }
        } else {
            return <Loader show={true}/>
        }


    }
}

Content.propTypes = {
    openWebsocket: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    let result = {};
    let loaded = {toppyRevenue: false, heutsRevenue: false};

    if (typeof state.data["event-toppy-current-stats"] !== "undefined") {
        loaded.toppyRevenue = true;
    }
    if (typeof state.data["event-heuts-current-stats"] !== "undefined") {
        loaded.heutsRevenue = true;
    }
    if (typeof state.data['analytics-users'] !== "undefined") {
        loaded.analytics = true;
    }
    if (typeof state.data['event-revenue-per-department'] !== "undefined") {
        loaded.revenuePerDepartment = true;
    }

    result.loaded = loaded;
    result.tvMode = state.app.tvMode;
    return {result};
};

export default connect(
    mapStateToProps,
    {openWebsocket}
)(Content);
